import React from 'react';
import * as formatters from '../../utils/formatters';
import { useTranslation } from 'react-i18next';

function NextDraw({ date }) {
    const { formatDateStringShort } = formatters;
    const { t } = useTranslation();

    return <div>{formatDateStringShort(date) ?? t('currentJackpot.pending')}</div>;
}

export default NextDraw;
